<template>
  <el-time-picker
    v-model="time"
    :value-format="valueFmt"
    :format="fmt"
    :editable="editable"
    :placeholder="placeholder">
  </el-time-picker>
</template>
<script>
  export default{
    name: 'time-picker',
    props: ['value', 'label','edit'],
    data(){
      return {
        time: this.value || '',
        placeholder: this.label || '请选择时间',
        valueFmt:this.valueFormat || 'HHmm',
        fmt:this.format || 'HH:mm',
        editable:this.edit || false
      }
    },
    mounted(){
    },
    methods: {

    },
    watch:{
      time(val){
          this.$emit('input',val)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/TimePicker.vue